import { render, staticRenderFns } from "./DialogEditBuilding.vue?vue&type=template&id=135b1ace"
import script from "./DialogEditBuilding.vue?vue&type=script&lang=js"
export * from "./DialogEditBuilding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports